import * as tslib_1 from "tslib";
import { ByteArrayBase } from "@awayjs/core";
import { OpCodes } from "./OpCodes";
import { ResourceBaseFlash } from "./ResourceBaseFlash";
var CubeTextureFlash = (function (_super) {
    tslib_1.__extends(CubeTextureFlash, _super);
    function CubeTextureFlash(context, size, format, forRTT, streaming) {
        if (streaming === void 0) { streaming = false; }
        var _this = _super.call(this) || this;
        _this._context = context;
        _this._size = size;
        _this._context.addStream(String.fromCharCode(OpCodes.initCubeTexture, (forRTT ? OpCodes.trueValue : OpCodes.falseValue)) + size + "," + streaming + "," + format + "$");
        _this._pId = _this._context.execute();
        _this._context._iAddResource(_this);
        return _this;
    }
    Object.defineProperty(CubeTextureFlash.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    CubeTextureFlash.prototype.dispose = function () {
        this._context.addStream(String.fromCharCode(OpCodes.disposeCubeTexture) + this._pId.toString() + ",");
        this._context.execute();
        this._context._iRemoveResource(this);
        this._context = null;
    };
    CubeTextureFlash.prototype.uploadFromImage = function (imageCube, side, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        var data = imageCube.getImageData(side).data;
        var pos = 0;
        var bytes = ByteArrayBase.internalGetBase64String(data.length, function () {
            return data[pos++];
        }, null);
        this._context.addStream(String.fromCharCode(OpCodes.uploadBytesCubeTexture) + this._pId + "," + miplevel + "," + side + "," + (this.size >> miplevel) + "," + bytes + "%");
        this._context.execute();
    };
    CubeTextureFlash.prototype.uploadCompressedTextureFromByteArray = function (data, byteArrayOffset /*uint*/, async) {
        if (async === void 0) { async = false; }
    };
    return CubeTextureFlash;
}(ResourceBaseFlash));
export { CubeTextureFlash };



// WEBPACK FOOTER //
// ../dist/lib/flash/CubeTextureFlash.js